import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useActiveFilters } from 'src/zustand/stores/filters.store'

import Icon from '../Icon/Icon'
import styles from './Checkbox.module.scss'

const Checkbox = ({ title, type }: { title: string; type: string }) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const addFilter = useActiveFilters((state) => state.addFilter)
  const isReset = useActiveFilters((state) => state.isReset)
  const setResetFilters = useActiveFilters((state) => state.setResetFilters)
  const { t } = useTranslation()

  useEffect(() => {
    if (isReset) {
      setIsActive(false)
      setResetFilters()
    }
  }, [isReset, setResetFilters])

  const handleCLick = () => {
    if (type === t('filters.type_of_deposit')) {
      addFilter(title, 'typesOfDeposits')
    } else if (type === t('filters.number_of_participants')) {
      addFilter(title, 'numbersOfParticipants')
    } else {
      addFilter(title, 'typesOfBottles')
    }

    setIsActive((prevState) => !prevState)
  }

  return (
    <div className={styles.checkbox} onClick={handleCLick}>
      <div className={`${styles.checkbox_block} ${isActive ? styles.active : ''}`}>
        {isActive && <Icon name='mark' />}
      </div>
      <p>{title}</p>
    </div>
  )
}

export default Checkbox
